import React, {memo, useCallback, useMemo, useState} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"
import {useSelector} from "react-redux"
import {useLocalization} from "../../../../hooks/localization"
import {SIPFormatType} from "../../../../store/control/state"
import {useSetSelector} from "../../../../hooks/set-selector"

const keyExtractor = (item: SIPFormatType) => item.id
export const SIPFormatListScreen = memo(function SIPFormatListScreen() {
    const formatList = useSelector(state => state.control.sipFormatTypeList)
    const formatListSet = useSetSelector(state => state.control.sipFormatTypeList)
    const [selectedColumn, setSelectedColumn] = useState<SIPFormatType>(null)
    const {t} = useLocalization()
    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 2,
                name: t("name"),
                key: "name"
            },
            {
                length: 4,
                name: t("format"),
                key: "format"
            },
            {
                length: 2,
                name: t("format_length"),
                key: "format_length"
            }
        ],
        [t]
    )

    const buttons = useMemo(
        () => [
            {
                text: t("edit"),
                url: `/developer/sip-format/edit/${selectedColumn ? selectedColumn?.id : ""}`,
                className: "orange",
                hidden: !selectedColumn
            },
            {
                text: t("create_format"),
                url: "/developer/sip-format/edit",
                className: "green"
            }
        ],
        [t, selectedColumn]
    )

    const displayNameExtractor = useCallback(
        (item: SIPFormatType, column: ColumnModel) => {
            if (column.key === "format_length") {
                return formatListSet[item?.id]?.format_lenght?.toString()
            }
            return item[column.key]?.toString() || "-"
        },
        [formatListSet]
    )

    return (
        <PasswordContainer requiredRole="developer" isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                className="camera-list-page"
                backUrl={"/developer"}
                searchable={true}
            >
                <SettingsList
                    columns={columns}
                    items={formatList}
                    listType="formatList"
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedColumn}
                    onItemSelected={setSelectedColumn}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
